export const ItemFragment = /* GraphQL */ `
	fragment ItemFragment on Item {
		_id
		created_at
		updated_at
		item_id
		cost
		title
		description
		title_localized {
			cn
			kh
		}
		description_localized {
			cn
			kh
		}
		banner_img
		is_qr_enabled
		is_pos_enabled
		no_vat
		no_service_charge
		is_open_item
		is_hide_from_receipt
		type
		prep_time
		is_template
		clone_from
		ordering_index
		extra_quantity
		printer_tag
		original_price
		minimum_required_price
		original_price_addons {
			vat {
				percentage
				amount
			}
			service_charge {
				percentage
				amount
			}
			service_charge_bd {
				percentage
				amount
			}
		}
		listed_price
		category
		menu
		venue
		recipe {
			raw_material
			unit_of_measurement
			consumed_unit_of_measurement
			consumed_quantity
		}
		options {
			ordering_index
			is_hide_from_receipt
			_option {
				_id
				created_at
				updated_at
				option_id
				cost
				title
				title_localized {
					cn
					kh
				}
				is_template
				clone_from
				original_price
				original_price_addons {
					vat {
						percentage
						amount
					}
					service_charge {
						percentage
						amount
					}
					service_charge_bd {
						percentage
						amount
					}
				}
				listed_price
				menu
				venue
				recipe {
					raw_material
					unit_of_measurement
					consumed_unit_of_measurement
					consumed_quantity
				}
			}
		}
		option_groups {
			is_required
			minimum_select
			maximum_select
			ordering_index
			options {
				ordering_index
				is_auto_select
				is_hide_from_receipt
				_option {
					_id
					created_at
					updated_at
					option_id
					cost
					title
					title_localized {
						cn
						kh
					}
					is_template
					clone_from
					original_price
					original_price_addons {
						vat {
							percentage
							amount
						}
						service_charge {
							percentage
							amount
						}
						service_charge_bd {
							percentage
							amount
						}
					}
					listed_price
					menu
					venue
					recipe {
						raw_material
						unit_of_measurement
						consumed_unit_of_measurement
						consumed_quantity
					}
				}
			}
			_option_group {
				_id
				title
				options {
					ordering_index
					_option {
						_id
						created_at
						updated_at
						option_id
						cost
						title
						title_localized {
							cn
							kh
						}
						is_template
						clone_from
						original_price
						original_price_addons {
							vat {
								percentage
								amount
							}
							service_charge {
								percentage
								amount
							}
							service_charge_bd {
								percentage
								amount
							}
						}
						listed_price
						menu
						venue
						recipe {
							raw_material
							unit_of_measurement
							consumed_unit_of_measurement
							consumed_quantity
						}
					}
				}
				clone_from
			}
		}
		is_master
		master_items
		item_tags
		is_quantity_controlled
		controlled_quantity
		till_card_color
		availability {
			days
			times {
				from
				to
			}
		}
	}
`;
